import InnerTile from "./inner-tile";

import './tile-style.css';

export const Tile = ({ project, tile, tileRef, provider, editable, showTileDelete, showPriorityBadge, showViewDetailsButton, onViewDetails }) => {

    return (
        <div className="m-5px tile"
            ref={tileRef}
            {...provider.draggableProps}
            {...provider.dragHandleProps}
        >
            <InnerTile 
                project={project} 
                tile={tile} 
                editable={editable} 
                deletable={showTileDelete}
                showPriorityBadge={showPriorityBadge}
                showViewDetailsButton={showViewDetailsButton}
                onViewDetails={onViewDetails}
            />
        </div>
    );
};